import React from 'react';
import { createRoot } from 'react-dom/client';
import UnifiedHeader from 'components/UnifiedHeader';
import UnifiedFooter from 'components/UnifiedFooter';
import ImpersonationBanner from 'components/ImpersonationBanner';
import { initializeHoneybadger } from 'utils/honeybadger';

// Mount UnifiedHeader and UnifiedFooter on all pages
// This ensures React is only loaded once, avoiding "Invalid hook call" errors
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Honeybadger JS SDK directly (no backend relay)
  initializeHoneybadger();

  // Mount UnifiedHeader
  const headerContainer = document.getElementById('unified-header-app');
  if (headerContainer) {
    const translations = JSON.parse(headerContainer.dataset.translations || '{}');
    const isHomepage = headerContainer.dataset.isHomepage === 'true';

    const headerRoot = createRoot(headerContainer);
    headerRoot.render(
      <UnifiedHeader
        translations={translations}
        userSignedIn={translations.user_signed_in}
        currentUserName={translations.current_user_name}
        currentRole={translations.current_role}
        userRoles={translations.user_roles}
        isMultiRole={translations.is_multi_role}
        isHomepage={isHomepage}
        unreadConversationsCount={translations.unread_conversations_count || 0}
        hideFindTeachers={!!translations.hide_find_teachers}
      />
    );
  }

  // Mount UnifiedFooter
  const footerContainer = document.getElementById('unified-footer-app');
  if (footerContainer) {
    const translations = JSON.parse(footerContainer.dataset.translations || '{}');

    const footerRoot = createRoot(footerContainer);
    footerRoot.render(
      <UnifiedFooter translations={translations} />
    );
  }

  // Mount ImpersonationBanner (for admin impersonation)
  const bannerContainer = document.getElementById('impersonation-banner-app');
  if (bannerContainer) {
    const translations = JSON.parse(bannerContainer.dataset.translations || '{}');

    // Only render banner if impersonating
    if (translations.impersonating && translations.impersonated_user_name) {
      const bannerRoot = createRoot(bannerContainer);
      bannerRoot.render(
        <ImpersonationBanner
          impersonatedUserName={translations.impersonated_user_name}
          impersonatedUserId={translations.impersonated_user_id}
          translations={translations}
        />
      );
    }
  }
});
